import * as React from "react";
import styles from "./Statistics.module.scss";

const Statistics = ({ data }) => {
  const [dataset, setDataset] = React.useState([])

  const mapBundle = {
    slowest: "The Slowest",
    most_rework: "The Most Rework",
    most_expensive: "The Most Expensive",
  }

  const handleMapBundle = (text) => {
    if (mapBundle[text]) {
      return mapBundle[text]
    } else return text
  }

  React.useEffect(() => {
    if (data) {
      const d = Object.entries(data)?.map(([key, _]) => {
        return Object.entries(data[key])?.map(([k, v]) => (
          {
            mainTitle: key,
            title: k,
            name: v.name,
            value: v.value
          }
        ))
      })
      setDataset(d.flat())
    }
  }, [data])

  return (
    <div className={'col-md-6'}>
      <div className={styles.statistics}>
        <div className={styles.header}>
          <div className={styles.title}>
            Statistics
          </div>
          <div className={styles.link}>
            <span className={'disable'}>Go to Data Analysis</span>
            <span>
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.8125 8.79428L3.5625 8.79428" stroke="#8A0FFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M10.2751 4.27598L14.8126 8.79398L10.2751 13.3127" stroke="#8A0FFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </span>
          </div>
        </div>
        <div className={styles.mainContent}>
          <div className={'row'}>
            {
              dataset.map(item => (
                <div className={['col-md-4', styles.item].join(' ')}>
                  <div className={styles.title}>
                    <span>{ handleMapBundle(item.mainTitle) }</span><span> { item.title }</span>
                  </div>
                  <div className={styles.name}>
                    { item.name }
                  </div>
                  <div className={styles.metric}>
                    { Number.isInteger(item.value) ? item.value?.toLocaleString() : item.value }
                  </div>
                </div>
              ))
            }
          </div>
        </div>
      </div>
    </div>
  )
}

export default Statistics